import styled from "styled-components";

export const SpinnerSection = styled.div`
  height: 500px;
`;
